import script from "./docLuBillAddOn.vue?vue&type=script&setup=true&lang=ts"
export * from "./docLuBillAddOn.vue?vue&type=script&setup=true&lang=ts"

import "./docLuBillAddOn.vue?vue&type=style&index=0&id=e14ae72a&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e14ae72a"]])

export default __exports__